<template>
	<v-container>
		<v-row v-if="!preload">
			<v-col cols="12" xs="12" class="position-relative pt-0 pb-0">
				<v-progress-linear :active="loading" absolute indeterminate class="ml-3 mr-3"
				                   color="green"></v-progress-linear>
			</v-col>
			<v-col>
				<v-data-table
						@page-count="pageCount = $event"
						:page.sync="page"
						:headers="headers"
						:items="items"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						class="safety-calendar loads-table"
						:search="search"
						:items-per-page="getItemsPerPage"
						:show-select="false"
						hide-default-footer
						hide-default-header
						hide-default-body
						fixed-header
				>
					<template v-if="isLoads" v-slot:top>
						<div class="d-flex">
							<v-col>
								<h2>Loads</h2>
							</v-col>
						</div>
					</template>
					<template v-slot:header="{ props: { headers } }">
						<thead class="v-data-table-header">
						<tr>
							<th v-if="processed">Purchased</th>
							<th
									:class="[{'orange--text':sortBy === item.value}, {'filter-active': filterClasses[item.value]}]"
									v-for="(item, index) in headers"
									:key="index"
									class="text-start sortable position-relative"
									:id="'container-'+item.value"
							>
								<v-menu
										:attach="'#container-'+item.value"
										:nudge-width="330"
										:max-width="330"
										:min-width="330"
										nudge-bottom="30"
										:close-on-content-click="false"
										transition="slide-x-transition"
										bottom
										right
										v-if="item.func"
										:content-class="'table-dd'"
								>
									<template v-slot:activator="{ on: menu, attrs }">
										<v-tooltip top color="teal">
											<template v-slot:activator="{ on: tooltip }">
                                                    <span v-bind="attrs"
                                                          v-on="{ ...tooltip, ...menu }">{{ item.text }}</span>
											</template>
											<span>Filter</span>
										</v-tooltip>
									</template>
									<v-list>
										<v-list-item v-if="item.value !== 'date'">
											<button @click="onFilteredAll(item)">Select all</button>
										</v-list-item>
										<v-list-item>
											<filter-table
													@change-sort="changeSort"
													@create-refresh="createRefresh"
													@filter-created="filterCreated"
													:refreshDate="refreshDate"
													:data-filter="filtersList[item.value]"
													:uniqId="uniqId"
													:model-filter="item.value"
													:filter-update="filterUpdate"
													:isDisabled="isDisabled"
											/>
										</v-list-item>
									</v-list>
								</v-menu>
								<span v-else>{{ item.text }}</span>
								<v-tooltip
										v-if="item.value !== 'notes'"
										color="orange"
										top
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
												v-bind="attrs"
												v-on="on"
												@click="toggleOrder(item.value)"
												icon
												x-small
												class="ml-4"
										>
											<v-icon
													:class="{'orange--text':sortBy === item.value}"
													class="sort-icon"
													size="14"
											>compare_arrows
											</v-icon>
										</v-btn>
									</template>
									<span>Sort</span>
								</v-tooltip>
							</th>
							<th v-if="isLoads && !processed" class="icons">
								<v-btn
										v-if="permissions['9'] || !editRow && permissions['8']"
										@click="removeAll"
										color="red"
										x-small
								>
									remove all
								</v-btn>
							</th>
							<th v-if="!isLoads && !processed" class="icons">
								<v-btn
										v-if="permissions['9'] || !editRow && permissions['8']"
										@click="addAll"
										color="green"
										x-small
								>
									add all
								</v-btn>
							</th>
						</tr>
						</thead>
					</template>
					<template v-slot:body="{ items }">
						<tbody>
						<template v-for="(item, index) in items">
							<table-tr
									:page="page"
									:key="index"
									:index="index"
									:itemsPerPage="getItemsPerPage"
									:dataVal="item"
									:purchased="!!item.purchased"
									:filterClasses="filterClasses"
									@updateActions="onActions"
									@updateIdView="onFiles"
									@updateSend="onSend"
									@updateCargoId="onCargoId"
									@updateRemoveCargoId="onRemoveCargoId"
									@updateCheckbox="onCheckbox"
									:isLoads="isLoads"
									:editRow="editRow"
									:processed="processed"
									:permissions="permissions"
							></table-tr>
						</template>
						</tbody>
					</template>
				</v-data-table>
			</v-col>
			<div class="pagination-wrap">
				<v-pagination
						v-if="pageCount > 1"
						v-model="page"
						:length="pageCount"
						:total-visible="7"
				></v-pagination>
			</div>
		</v-row>
		<preview-doc v-if="link" @clear-link="clearLink" :link-doc="link"/>
		<schedules-popup
				:isSchedulesPopup="isSchedulesPopup"
				@updateFile="onPreview"
				@updateClose="onSchedulesPopup"
				:filesList="filesList"
		></schedules-popup>
	</v-container>
</template>
<script>
import { mapActions } from "vuex";
// components
import FilterTable from "@/components/Safety/Logbooks/SafetyCalendar-list/filter-table/filter-table.component";
import TableTr from "@/components/Accounting/Schedules/Loads/LoadsTr/LoadsTr";
import PreviewDoc from "@/modules/invoices/preview";
import SchedulesPopup from "@/components/Accounting/Schedules/SchedulesPopup/SchedulesPopup";
// helper
import getUniqId from "@/helper/getUniqId";
import { getAppUrl } from "@/services";

export default {
	name: 'Loads',
	components: {
		FilterTable,
		TableTr,
		PreviewDoc,
		SchedulesPopup
	},
	props: {
		listItems: Array,
		filtersList: Object,
		isLoads: Boolean,
		editRow: Object,
		processed: Boolean,
		permissions: Object
	},
	computed: {
		getItemsPerPage() {
			return this.itemsPerPage === 'All' ? 99999999 : this.itemsPerPage;
		},
		getLength() {
			return Object.values(this.customersData).length;
		},
		checkedRow() {
			return Object.values(this.customersData).every(item => !item.checked);
		},
		headers() {
			return [
				{ text: "Trip ID", value: "trip_id", func: false, filterable: false, sortable: false },
				{ text: "Load ID", value: "load_id", func: false, filterable: false, sortable: false },
				{ text: "Truck#", value: "truck", func: false, filterable: false, sortable: false },
				{ text: "Route", value: "routs", func: false, filterable: false, sortable: false },
				{ text: "Broker load #", value: "broker_number", func: false, filterable: false, sortable: false },
				{ text: "Broker", value: "broker_name", func: false, filterable: false, sortable: false },
				{ text: "Gross", value: "gross", func: false, filterable: false, sortable: false },
				{ text: "Amount", value: "amount", func: false, filterable: false, sortable: false },
				{ text: "PPW", value: "file", func: false, filterable: false, sortable: false },
			];
		},
		listValues() {
			const arr = [];
			for (let i = 0; i < this.headers.length; i++) {
				arr.push(this.headers[i].value);
			}
			return arr;
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = !!arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
		items: {
			get() {
				return this.listItems;
			},
			set(arr) {
				this.listItems = arr;
			},
		},
	},
	data() {
		return {
			pages: [ 20, 50, 100, 200, 500, "All" ],
			itemsPerPage: 20,
			page: 1,
			pageCount: 0,
			employeeValue: '',
			valid: true,
			loading: false,
			checkItemPay: null,
			checkItemSend: null,
			filterUpdate: false,
			uniqId: { key: '', id: '' },
			refreshDate: null,
			sortBy: "",
			sortDesc: false,
			up: [],
			search: "",
			link: null,
			menu: false,
			preload: false,
			filtersMarker: {},
			filters: {},
			checkClasses: {},
			list: this.listItems,
			itemRemove: null,
			filterModList: {},
			isDisabled: false,
			lazy: false,
			preloader: false,
			snackbarSend: false,
			customersData: [],
			showSend: false,
			mailRules: [ (v) => /^$|.+@.+\..+/.test(v) || "E-mail must be valid" ],
			forEmails: [ { mail: '' } ],
			sendId: null,
			filesList: [],
			isSchedulesPopup: false
		};
	},
	created() {
		for (let i = 0; i < this.headers.length; i++) {
			this.filtersMarker[this.headers[i].value] = true;
			this.checkClasses[this.headers[i].value] = false;
			this.filters[this.headers[i].value] = [];
		}
	},
	methods: {
		...mapActions([ 'safetyCalendar', 'onCreateSafetyReports', 'onSentSafetyReports' ]),
		onSchedulesPopup() {
			this.isSchedulesPopup = false;
		},
		onCheckbox(values) {
			this.$emit('updateCheckbox', values);
		},
		onSend(id) {
			this.sendId = id;
			this.showSend = true;
		},
		onFiles(files) {
			this.isSchedulesPopup = true;
			this.filesList = files ?? [];
		},
		onPreview(file) {
			this.link = file.includes('data:') ? file : getAppUrl + file;
		},
		clearLink() {
			this.link = null;
		},
		async onCreateSafety() {
			this.preloader = true;
			try {
				const { data } = await this.onCreateSafetyReports({ data: this.filterModList });
				if (data && data.status) {
					for (const key in data.customers) {
						data.customers[key].checked = true;
					}
					this.customersData = data.customers;
					this.snackbarSend = true;
				}
			} catch (e) {
				console.error(e);
			}

			this.preloader = false;
		},
		onFilteredAll(item) {
			this.filterCreated(item.value);
			this.uniqId = {
				id: getUniqId(),
				key: item.value
			};
		},
		onActions(values) {
			this.$emit('updateActions', values);
		},
		refreshFilters() {
			this.sortDesc = false;
			this.itemsPerPage = 20;
			this.sortBy = "";
			this.refreshDate = getUniqId();

			for (const variable in this.filterModList) {
				this.filterClasses[variable] = false;
			}

			this.safetyCalendar();
		},
		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}
			this.filterClasses = this.filters;
		},

		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
		async changeSort({ key, value }) {
			if (key === 'filter_date') {
				this.filterModList[key] = value;
			} else {
				this.filterModList[key] = value.map(item => item);
			}

			for (const variable in this.filterModList) {
				this.filterClasses[variable] = !!this.filterModList[variable].length;
			}

			this.$emit('updateSort', this.filterModList);
			this.isDisabled = true;
			await this.safetyCalendar(this.filterModList);
			this.isDisabled = false;
		},
		toggleOrder(val) {
			switch (val) {
				case 'filterCustomer':
					this.sortBy = 'customer_name';
					break;
				case 'filterDriver':
					this.sortBy = 'driver_name';
					break;
				case 'filterEld':
					this.sortBy = 'eld_name';
					break;
				case 'filterPhone':
					this.sortBy = 'driver_phone';
					break;
				case 'filterTruck':
					this.sortBy = 'truck';
					break;
				case 'filterTrailerType':
					this.sortBy = 'trailer_type';
					break;
				default:
					this.sortBy = val;
			}

			//this.sortBy = val;
			this.sortDesc = !this.sortDesc;
		},
		onNewSchedule() {
			this.$emit('updateScheduleComponent');
		},
		onCargoId(id) {
			this.$emit('updateCargoId', id);
		},
		onRemoveCargoId(id) {
			this.$emit('updateRemoveCargoId', id);
		},
		addAll() {
			this.$emit('updateAddAll');
		},
		removeAll() {
			this.$emit('updateRemoveAll');
		}
	}
};
</script>
<style lang="scss">
.safety-calendar.loads-table .v-data-table__wrapper {
	min-height: initial !important;
}
</style>
<style lang="scss" scoped>
@import "./loadsList";
</style>
<style lang="scss">
.loads_table .v-input--selection-controls.v-input {
	height: initial;
}

.safety-calendar.theme--dark.v-data-table.v-data-table--fixed-header .v-data-table-header thead th {
	background: none !important;
}

.comment {
	min-width: 100px;
}

.safety-calendar.loads-table {
	.v-data-table__wrapper {
		overflow: auto !important;
		max-height: 604px;
		min-height: 400px;

		td, th {
			white-space: nowrap;
		}
	}
}

.loads-table {
	.v-data-table__wrapper {
		overflow-y: initial !important;
		overflow-x: initial !important;
	}

	&.v-data-table td {
		font-size: 12px !important;
		height: 36px !important;
	}

	.eld {
		a {
			display: inline-block;
			margin-right: 10px;
		}

		button {
			margin-right: 2px;
		}
	}
}

.createReportsItems {
	max-height: 200px;
	overflow-y: auto;

	.createReportsItem {
		display: flex;
		align-items: center;

		.cell {
			padding-top: 0;
			padding-bottom: 0;
		}
	}
}

.reportsPreview {
	z-index: 200 !important;
}
</style>
